import i18next from "i18next";

export default function i18nUtil(key : string, option = {}) {
   // @ts-ignore
   if (window.props && window.props.i18next) return window.props.i18next.t(key, option) as string;
   return i18next.t(key, option) as string;
}
